import React from 'react';
import Gallery from '../components/Gallery';
import { poolsAndLandscapesImages } from '../utils/imageUtils';

const PoolsAndLandscapes: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Pools & Landscapes</h1>
        <div className="prose max-w-none">
          <p className="text-lg text-gray-700 mb-6">
            Create your perfect outdoor oasis with our pool construction and landscaping expertise.
            We design and build stunning outdoor spaces that combine beauty with functionality.
          </p>
          <div className="mt-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-6">Our Pool & Landscape Projects</h2>
            <Gallery images={poolsAndLandscapesImages} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoolsAndLandscapes; 